import * as z from 'zod';

import { AddressSchema } from '../shared/address-schema.ts';

export const SupporterPostBaseSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  address: AddressSchema,
  phone: z.string().optional(),
});

export type SupporterPostBase = z.infer<typeof SupporterPostBaseSchema>;

export const SupporterPostRequestSchema = SupporterPostBaseSchema.extend({
  email: z.email(),
});

export type SupporterPostRequest = z.infer<typeof SupporterPostRequestSchema>;
